module.exports = __webpack_public_path__ + "img/icon-dexpn.d458de83.svg";